export const LANGUAGES = {
  EN: "en",
  ES: "es",
};
